"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const external_frame_1 = require("@clearsummit/external-frame");
const react_1 = __importDefault(require("react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Button = (_a) => {
    var { variant, className, disabled } = _a, props = __rest(_a, ["variant", "className", "disabled"]);
    return (react_1.default.createElement(external_frame_1.Button, Object.assign({ className: (0, carabiners_1.joinStr)(styles_scss_1.default.button, variant === "error" ? styles_scss_1.default.error : "", variant === "secondary" ? styles_scss_1.default.secondary : "", disabled ? styles_scss_1.default.disabled : "", className), disabled: disabled }, props)));
};
Button.defaultProps = {
    variant: 'primary',
    className: undefined,
    disabled: false
};
exports.default = Button;
